import { createClient } from '@supabase/supabase-js'

declare global {
  interface Window {
    ENV: {
      VITE_SUPABASE_URL: string
      VITE_SUPABASE_ANON_KEY: string
      VITE_API_URL: string
    }
  }
}

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit',
  },
})

// Add an empty export to ensure this is treated as a module
export {} 